import styles from "./style.module.scss";

export const TransitionHOC = ({ children }) => {
  return <div className={styles.fadeInContainer}>{children}</div>;
};
